module.exports = {
  "scaleTemplate": {},
};



// WEBPACK FOOTER //
// ./src/i18n/scaleTypeTemplate/en.js